import React from 'react';
import ContactComponent from '../components/contact/contact';

function ContactusPage(){
    return (
        <>
            <ContactComponent/>
        </>
    )
}
export default ContactusPage